import { createReminder } from 'components/partials/communications/communicationMixin'

export const STAFF_REMINDER_LIMIT = 3
export const UNSCHEDULED_REMINDER_LIMIT = 1
export const CLIENT_REMINDER_LIMIT = 3

/**
 * Add staff reminder to appointment model
 * @param model
 * @param offset
 */
export function addStaffReminder (model, offset = null) {
  if (model.staff_reminders.length >= STAFF_REMINDER_LIMIT) {
    return
  }

  model.staff_reminders.push(createReminder({
    key: 'staff'
  }, offset ? [] : model.staff_reminders, offset ?? -60, -1440))
}

/**
 * Add default set of staff reminders for this appointment
 * @param model
 */
export function addDefaultStaffReminders (model) {
  model.staff_reminders = []

  if (model.attendees.length < 1) {
    return
  }

  // If no appointment type, set single default reminder
  if (model.types.length < 1) {
    addStaffReminder(model)
    return
  }

  for (const offset of model.types[0].staff_reminder_offset) {
    addStaffReminder(model, offset)
  }
}

/**
 * Add unscheduled staff reminder to appointment model
 * @param model
 */
export function addUnscheduledReminder (model, offset = null) {
  if (model.unscheduled_reminders.length >= UNSCHEDULED_REMINDER_LIMIT) {
    return
  }

  model.unscheduled_reminders.push(createReminder({
    key: 'unscheduled'
  }, offset ? [] : model.unscheduled_reminders, offset ?? -20160, -1440))
}

/**
 * Add default set of unscheduled reminders for this appointment
 * @param model
 */
export function addDefaultUnscheduledReminders (model) {
  model.unscheduled_reminders = []

  // If no appointment type, set single default reminder
  if (model.types.length < 1) {
    addUnscheduledReminder(model)
    return
  }

  for (const offset of model.types[0].unscheduled_reminder_offset) {
    addUnscheduledReminder(model, offset)
  }
}

/**
 * Add client reminder to appointment model
 * @param model
 * @param client
 * @param offset
 * @param force
 */
export function addClientReminder (model, client, offset = null, force = false) {
  const clientReminders = model.client_reminders.filter(item => item.client_id === client.id)
  if (clientReminders.length >= CLIENT_REMINDER_LIMIT) {
    return
  }

  if (!force && client.disable_reminders) {
    return
  }

  model.client_reminders.push(createReminder({
    client_id: client.id,
    type: client.default_communication_method,
    key: 'clients'
  }, offset ? [] : clientReminders, offset ?? -1440, -1440))
}

/**
 * Add default set of reminders for this appointment and client
 * @param model
 * @param client
 */
export function addDefaultClientReminders (model, client) {
  model.client_reminders = model.client_reminders.filter(item => item.client_id !== client.id)

  // If no appointment type, set single default reminder if allowed by the client's settings
  if (model.types.length < 1) {
    addClientReminder(model, client)
    return
  }

  for (const offset of model.types[0].client_reminder_offset) {
    addClientReminder(model, client, offset)
  }
}
